<template>

  <div class="modal fade slide-right" id="paymentModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
      <div class="modal-dialog modal-sm modal-payment" style="width: 35%;">
          <div class="modal-content-wrapper">
              <div class="modal-content">
                  <div class="modal-header clearfix text-left">
                      <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="$emit('cancel')">
                        <i class="pg-close fs-14"></i>
                      </button>

                  </div>
                  <div class="modal-body"  >
                      <div class="col-md-12 modal-right">

                        <h1>Commande n° {{order.ihrez}}</h1>
                        <h2>Total T.T.C = {{(order.total_to_pay / 100).toFixed(2)}}€</h2>
                        <label>Séléctionner un mode de paiement</label>
                        <custom-select :field="fields[0]" :value="fields[0].value" :field_idx="0" @field-updated="update_selected_method">
                        </custom-select>
                        <div v-if="selected_method != null" style="margin-top: 15px;">
                          <notifications v-if="anyError && finalModal && finalModal.form && finalModal.form.schema && finalModal.form.model && formError != null"
                                          :error="formError"
                                          :fields="notificationFields"
                                          :model="finalModal.form.model">
                          </notifications>
                          <resource-form v-if="finalModal"
                                         ref="paymentForm"
                                         :schema="finalModal.form.schema"
                                         :model="finalModal.form.model"
                                         :realtimeUpdate="true"
                                         @submit="handleFormSubmit"
                                         :submit-button="false"
                                         :customNotif="true">
                          </resource-form>
                        </div>

                      </div>
                    </div>
                  <div class="modal-footer">
                    <button class="btn btn-default" @click="resetData" v-if="selected_method != null">
                      <span>Annuler</span>
                    </button>
                    <button class="btn btn-complete sm" @click="onClick" v-if="selected_method !== 3 && selected_method !== null">
                      <span>Payer</span>
                    </button>
                  </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState, mapActions} from "vuex"
// import ResourceForm from "components/Form/ResourceForm"
import ResourceForm from "components/Forms/ResourceForm"

import Notifications from "components/Form/Notifications"
import CustomSelect from "components/Forms/Elements/Select"
import cookies from "cookiesjs"

export default {
  name:"OrderPaymentModal",

  components:{
    ResourceForm,
    Notifications,
    CustomSelect,
  },

  props:["order"],

  data () {
    return {
      readyToRender:false,
      selected_method: null,
      modal: null,
      block: null,
      dataToSend:null,
      formError:null,
    }
  },

  created() {
    this.all_payments_methods
  },

  mounted() {
    $(this.$el).modal()
  },

  beforeDestroy() {
    $(this.$el).modal('hide')
    $('body').removeClass('modal-open')
    $('.modal-backdrop').remove()
  },

  methods:{
    ...mapActions('demands', ['getPaymentMethods','make_payment','captureAutorizations']),

    resetData(){
      this.selected_method= null
      this.modal= null
      this.block= null
      this.dataToSend=null
    },

    onClick () {
      if (this.dataToSend.data)
      {
        let payload = {
          order_id: this.order.id, 
          other: this.dataToSend.data
        }
        
        // this.$refs.paymentForm.handleSubmit({})
        this.formError = null
        this.make_payment(payload)
            .then(
              () => this.$emit("close-after-sucess", true),
              (error) => {
                this.formError = error.response.data
                // The order may have been paid online meanwhile: the list hides its payment button
                this.$emit("payment-refused")
              }
            )
      }
      else
        console.error('Missing params to store payment')
    },

    handleFormSubmit(event)
    {
      if (event)
      {
        console.log(event)
        this.dataToSend = event
      }
    },

    update_selected_method(event) {
      if (event && event.new_value) {
        if (3 === event.new_value.value) {
          this.redirectToHostedCheckout()
        } else {
          this.selected_method = event.new_value.value
        }
      } else {
        this.selected_method = null
      }
    },

    redirectToHostedCheckout() {
      const params = {
        token: cookies('token'),
        origin_url: 'AGENCY_SPACE_URL',
        route_name: this.$route.name,
        route_id: this.$route.params.id,
        tab: 'orders',
        locale: navigator.language,
        timezoneOffsetUtcMinutes: (new Date).getTimezoneOffset(),
        browserColorDepth: screen.colorDepth,
        browserScreenHeight: screen.height,
        browserScreenWidth: screen.width
      }

      const urlParamsForPHP = $.param(params)

      window.location = `${__API_URL__}/orders/${this.order.id}/hosted_checkout_page?${urlParamsForPHP}`
    }
  },

  computed:{
    ...mapState('demands', ['payment_methods']),

    all_payments_methods(){
      if (this.order != null && this.order != undefined && this.order != false)
        {
          this.getPaymentMethods({order_id:this.order.id})
              .then(() => this.readyToRender = true)
          return true
        }
      return false
    },

    normalizedPaymentMethod () {
      if (this.all_payments_methods) {
        var cpy = _.clone(this.payment_methods)
        var res = (_.map(cpy, function (pm, idx) { return ({ id: idx, name: pm.block.title, validation_method: pm.modal.form.model.validation_method }) }))
        return res
      }
    },

    finalModal() {
      if (this.modal)
        return this.modal
      return false
    },

    finalBlock() {
      if (this.block)
        return this.block
      return false
    },

    anyError() {
      // debugger
      return (this.formError) ?  true : false
    },

    // The payment method is chosen outside the form: without it, the notifications would leave its refusal aside
    notificationFields() {
      return _.concat(this.finalModal.form.schema.fields, [{model: 'payment_method', label: 'Mode de paiement'}])
    },

    fields() {
      let npm = _.concat([{id:3, name:"CB en ligne"}], this.normalizedPaymentMethod)
      let v = [
        {
          values:npm, multiple:false, placeholder:"",
          disabled:false, idx:0, required:false, value:this.selected_method, label:"",type:"select"
        },
      ]
      return v
    }
  },

  watch :{
    selected_method: function (newv, oldv) {
      if (this.payment_methods) {
        this.modal = null
        this.block = null
        this.formError = null
        this.$forceUpdate()
        this.$nextTick(() => {
          if (this.payment_methods[newv] != undefined) {
            this.modal = this.payment_methods[newv].modal
            this.block = this.payment_methods[newv].block
            this.$forceUpdate()
          }
        })
      }
    },
  },

}
</script>
<style scoped>
.order-payment-modal-background {
  /*width: 100%;
  height: 100%;
      top: 0;
  z-index:1;
  position:absolute;
  background-color: rgba(0, 0, 0, 0.5);*/
}

.order-payment-modal-container {
  /*width:100%;
  height:100%;*/
}

.order-payment-modal-body {
  /*background-color: white;
  position: relative;
  z-index:2;
  width:100%;*/
}
</style>



// WEBPACK FOOTER //
// client/components/Customer/OrdersTabContent/OrderPaymentModal.vue